// Copyright 2026 Hardfin, Inc.
import { LocationName } from '@/components/location-name';
import { LocationOnOutlined } from '@/constants/hardfin-standard-icons';
import { isEffectiveThirdPartyEnabled } from '@/location/utilities/get-effective-third-party';
import { Chip, Stack, Typography } from '@mui/material';

export interface LocationForLabel {
  name: string;
  type?: 'SITE' | 'ZONE';
  zoneCount?: number;
  address: { formattedAddress: string | null } | null;
  isThirdPartyEnabled: boolean;
  parentLocation?: {
    name: string;
    address: { formattedAddress: string | null } | null;
    isThirdPartyEnabled: boolean;
  } | null;
}

interface LocationLabelProps {
  label: string;
  location: LocationForLabel | null;
  showThirdPartyChip?: boolean;
}

export function LocationLabel(props: LocationLabelProps) {
  return (
    <Stack direction="row" alignItems="flex-start" flexWrap="wrap" gap={0.3}>
      <Stack direction="row" alignItems="center" gap={0.3}>
        <LocationOnOutlined sx={{ fontSize: '1rem' }} />
        <Typography variant="subtitle2">{props.label}</Typography>
      </Stack>
      {props.location ? (
        <Stack direction="row" alignItems="center" gap={0.5}>
          <LocationName
            location={props.location}
            showAddress="tooltip"
            variant="body2"
          />
          {props.showThirdPartyChip &&
            isEffectiveThirdPartyEnabled(props.location) && (
              <Chip label="3PL" size="small" />
            )}
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Not set
        </Typography>
      )}
    </Stack>
  );
}
